export const SERVICES_RESET_STATE = 'SERVICES_RESET_STATE';
export const SERVICES_CURRENT_ITEM = 'SERVICES_CURRENT_ITEM';

export const SERVICES_REQUEST_LOADING = 'SERVICES_REQUEST_LOADING';
export const SERVICES_REQUEST_SUCCESS = 'SERVICES_REQUEST_SUCCESS';
export const SERVICES_REQUEST_FAILED = 'SERVICES_REQUEST_FAILED';

export const SERVICES_CURRENT_ACTION = 'SERVICES_CURRENT_ACTION';
export const SERVICES_RESET_ACTION = 'SERVICES_RESET_ACTION';